import { ErrorApi } from 'api/interfaces';
import parametrosApi, {
  ParametrosAssociadoResponse,
} from 'api/Associado/parametros';
import eventoApi, { ProximosEventosResponse } from 'api/EventoAssociado/evento';
import documentoApi from 'api/EventoAssociado/documentos';
import presencaApi from 'api/Associado/presenca';
import browserTrigger from 'helpers/utils/DownloadTrigger';
import { ThunkActionAssociado } from './interfaces';

/*
 *  ParametrosApi Actions
 */

export const associadoActionCarregarParametros = (
  callbackSuccess?: (data: ParametrosAssociadoResponse) => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionAssociado => {
  return async (dispatch) => {
    dispatch({
      type: 'loadindParametros',
      payload: true,
    });
    const { fail, data } = await parametrosApi.listar();
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      dispatch({
        type: 'setParametros',
        payload: data,
      });
      callbackSuccess && callbackSuccess(data);
    }
    dispatch({
      type: 'loadindParametros',
      payload: false,
    });
  };
};

/*
 *  EventoApi Actions
 */

export const associadoActionListarProximosEventos = (
  callbackSuccess?: (lista: ProximosEventosResponse) => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionAssociado => {
  return async (dispatch) => {
    dispatch({
      type: 'loadingProximosEventos',
      payload: true,
    });
    const { fail, data } = await eventoApi.listarProximos();
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      dispatch({
        type: 'setProximosEventos',
        payload: data,
      });
      callbackSuccess && callbackSuccess(data);
    }
    dispatch({
      type: 'loadingProximosEventos',
      payload: false,
    });
  };
};

/*
 *  DocumentoApi Actions
 */

export const associadoActionBaixarDocumento = (
  idEvento: number,
  idDocumento: number,
  fileName: string,
  callbackSuccess?: () => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionAssociado => {
  return async (dispatch) => {
    dispatch({
      type: 'downloadingFile',
      payload: idDocumento,
    });
    const { fail, data } = await documentoApi.download(idEvento, idDocumento);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      browserTrigger(fileName, data);
      callbackSuccess && callbackSuccess();
    }
    dispatch({
      type: 'downloadingFile',
      payload: null,
    });
  };
};

/*
 *  PresencaApi Actions
 */

export const associadoActionBuscarUsuariosOnline = (
  idEvento: number,
  callbackError: (error: ErrorApi) => void,
  callbackSuccess?: () => void
): ThunkActionAssociado => {
  return async (dispatch, getState) => {
    dispatch({
      type: 'buscandoUsuariosOnline',
      payload: true,
    });
    const currentEvent = getState().assembleias.currentEvent;
    if (!currentEvent || currentEvent.id !== idEvento) {
      dispatch({
        type: 'buscandoUsuariosOnline',
        payload: false,
      });
      return;
    }
    const { fail, data } = await presencaApi.presencasPorEvento(idEvento);
    if (fail) {
      callbackError(fail);
    }
    if (data) {
      dispatch({
        type: 'setUsuariosOnline',
        payload: data.quantidadePessoasOnline,
      });
      callbackSuccess && callbackSuccess();
    }
    dispatch({
      type: 'buscandoUsuariosOnline',
      payload: false,
    });
  };
};
